import $ from 'jquery';

export class Menu {
  public static frontend(elem: HTMLElement) {
    return new this($(elem));
  }

  constructor(public $el: JQuery) {
    const $activeItem = $el.find('.menu-item.active');
    $activeItem.parents('.menu-item').addClass('active');
    this.calcHeight();
    $(window).resize(() => this.calcHeight());
  }

  public calcHeight() {
    const $this = this.$el.children('.me-Menu').children('.menu-item');
    const winHeight = $(window).height();
    $this.children('a').hover((e) => {
      const $el = $(e.target).next('.sub-menu');
      if ($el.length) {
        const currentPos = $el[0].getBoundingClientRect().top;
        if ($el.height() > winHeight - currentPos) {
          $el.css({
            maxHeight: `${winHeight - currentPos}px`,
            overflowY: 'auto',
            overflowX: 'visible',
          });
        }
      }
    });
  }
}
